import type {
    RadioGroupWithTextInputData,
    RadioGroupWithTextInputProps,
} from '@ksyos/design-system/dist/components/radio-group-with-text-input';
import type { OmittedFormGroupFieldProps } from '@frontend/components/fields/FormGroup';
import { getValidationErrorTranslation } from './getValidationErrorTranslation';

export type RadioGroupWithTextInputFieldProps = Omit<RadioGroupWithTextInputProps, 'layout'> & {
    radioGroupLayout?: RadioGroupWithTextInputProps['layout'];
};

export type RadioGroupWithTextInputFormGroupFieldProps = OmittedFormGroupFieldProps & RadioGroupWithTextInputFieldProps;

export function computeRadioGroupWithTextInputProps({
    checkError,
    error,
    onChange,
    onClearValue,
    options,
    radioGroupLayout,
    value,
}: RadioGroupWithTextInputFieldProps): RadioGroupWithTextInputProps {
    return {
        checkError,
        error: getValidationErrorTranslation(error),
        layout: radioGroupLayout,
        onChange,
        onClearValue,
        options,
        value,
    };
}

/**
 * Creates radio group options from an array of strings.
 * If a textInputLabel is provided, it will be added to the last option.
 *
 * @param {string[]} options - The array of option strings.
 * @param {string} [textInputLabel] - The label for the text input to be added to the last option.
 * @returns {RadioGroupWithTextInputData} The array of radio group options with optional text input label.
 */
export function createRadioGroupOptions(options: string[], textInputLabel?: string): RadioGroupWithTextInputData {
    const radioGroupOptions = options.map((option) => ({
        label: option,
    })) as RadioGroupWithTextInputData;
    if (textInputLabel) {
        radioGroupOptions.push({
            isTextInput: true,
            label: textInputLabel,
        });
    }

    return radioGroupOptions;
}
